export const appVersion = "1.0.0";
export const baseURL = "https://api.ceviliyar.in";
// export const baseURL = "https://api.ceviliyar.in";